export default "__VITE_ASSET__Dth2azfF__"